import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-system-error-message',
  templateUrl: './system-error-message.component.html',
  styleUrls: ['./system-error-message.component.scss']
})
export class SystemErrorMessageComponent {

  @Input()
  public message: string;

}
